/**
 * Stacking layers of portaled overlays. Everything below lives in `<body>`, so only z-index decides what is on top:
 * - side panels: {@link LAYER_PANEL} + 2 per stacked level (overlay, then panel), at most {@link MAX_PANEL_DEPTH} levels;
 * - modal layers (dialogs, alert dialogs, sheets): above every panel they can be opened from;
 * - floating layers (menus, popovers, selects, tooltips, hover cards, mention suggestions): above everything.
 * The class names are literals so Tailwind generates them; `layers.test.ts` keeps them in line with the numbers.
 */
export const LAYER_PANEL = 40;
export const MAX_PANEL_DEPTH = 14;
export const LAYER_MODAL = 70;
export const LAYER_FLOATING = 80;

export const layerClass = {
  modal: 'z-[70]',
  floating: 'z-[80]',
} as const;

/** z-index of a side panel level: `0` = its overlay, `1` = the panel. */
export function panelLayer(depth: number, offset: 0 | 1): number {
  return LAYER_PANEL + Math.min(Math.max(depth, 0), MAX_PANEL_DEPTH) * 2 + offset;
}
